import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-base',
  templateUrl: './register-base.component.html',
  styleUrls: ['./register-base.component.css']
})
export class RegisterBaseComponent {

  constructor(private router: Router) { }

  signin() {
    localStorage.removeItem('token');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('username');
    this.router.navigate(['/login']);
  }
}
